export const checklistTagMap = {
    miniAudit: {
        name: 'Prelim. Assessment',
        tip: 'This item has been generated by the Mini Audit.',
    },
};
